module.exports = __webpack_public_path__ + "static/media/droopy_upper.00905760.svg";